import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';

export default class AccountTransfer extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            organizationId: props.OrganizationId,
            accountType: props.AccountType,
            data: null,
            loading: true,
            toId: this.getDefaultGuid(),
            toTafsilId: this.getDefaultGuid(),
            tafsilChangeType: 0
        };
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/account/get", {
            id: this.state.id,
            type: this.state.accountType,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    transfer(e) {
        if (!this.isNull(e)) e.preventDefault();

        this.httpPost("api/v1/account/transfer", {
            id: this.state.id,
            toId: this.state.toId,
            organizationId: this.state.organizationId,
            accountType: this.state.accountType,
            tafsilChangeType: this.state.tafsilChangeType,
            toTafsilId: this.state.toTafsilId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("انتقال آرتیکل ها با موفقیت انجام پذیرفت");
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="modal fade in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog modal-lg" role="document" style={{ "width": "96%" }}>
                <div className="modal-content">
                    <div className="modal-body" id="DocumentModalViewerContent">
                        <div className="panel panel-info center-block" style={{ "max-width": " none" }}>
                            <div className="modal-header modal-header-info" style={{ "padding": "0" }}>
                                <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                                <h4 className="modal-title">انتقال حساب</h4>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label className="title1">حساب مقصد</label>
                                            <SelectAsync
                                                style={{ "width": "100%" }}
                                                defaultValue={null}
                                                isMulti={false}
                                                placeholder="انتخاب حساب مقصد"
                                                defaultOptions
                                                loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, this.state.accountType)}
                                                onChange={e => this.state.toId = e.value}
                                            />
                                        </div>
                                    </div>
                                    {this.state.accountType === 3 &&
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label className="title1">تغییر تفاصیل</label>
                                                <select className="form-control" onChange={e => this.setState({ tafsilChangeType: parseInt(e.target.value) })} defaultValue={this.state.tafsilChangeType}>
                                                    <option value="0">تفاصیل آرتیکل ها تغییر ندارند</option>
                                                    <option value="1">تغییر کلیه تفاصیل آرتیکل ها</option>
                                                    <option value="2">تغییر کلیه آرتیکل های فاقد تفصیل</option>
                                                </select>
                                            </div>
                                        </div>}
                                    {this.state.tafsilChangeType !== 0 && <div className="col-sm-8">
                                        <div className="form-group">
                                            <label className="title1">تفصیل انتخابی</label>
                                            <SelectAsync
                                                style={{ "width": "100%" }}
                                                defaultValue={null}
                                                isMulti={false}
                                                placeholder="انتخاب حساب تفصیل"
                                                defaultOptions
                                                loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 4)}
                                                onChange={e => this.state.toTafsilId = e.value}
                                            />
                                        </div>
                                    </div>}
                                    <div className="col-sm-12">
                                        <p className="text-red">توجه: با انجام این عملیات، کلیه آرتیکل های اسناد موقت سال مالی انتخابی به حساب مقصد انتخابی فوق منتقل خواهند شد</p>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" onClick={e => this.transfer(e)}>انتقال</button>
                                <a className="btn btn-warning" onClick={e => this.closeMe()} > انصراف</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
            ];

        return contents;
    }
}